import { Avatar, styled } from '@mui/material';

import { colorNeutral, colorPrimary } from '../../../styles/mui/colors';
import { colorNeutralBaseStyle } from '../../../styles/mui/components/shared';

import { AvatarSize } from './types';

export const avatarSizeMap: Record<AvatarSize, string> = {
  large: 'var(--size-avatar-large)',
  medium: 'var(--size-avatar-medium)',
  small: 'var(--size-avatar-small)',
};

type AvatarProps = {
  'data-is-inactive': boolean;
  'data-is-pending': boolean;
  'data-size': AvatarSize;
};

/**
 * Get Avatar size
 *
 * @param props Props passed to Avatar component
 * @returns     Dimensions of the avatar (height and width)
 */
const getAvatarSize = (props: AvatarProps) => {
  const avatarSize = avatarSizeMap[props['data-size']];

  return {
    height: avatarSize,
    width: avatarSize,
  };
};

/**
 * Get styles for inactive state
 *
 * @param props Props passed to Avatar component
 * @returns     Styles or empty object
 */
const getInactiveStyles = (props: AvatarProps) => {
  if (props['data-is-inactive'] === false) {
    return {};
  }

  return {
    backgroundColor: colorNeutral[400],
    color: colorPrimary[500],
    filter: 'blur(0.7px)',
  };
};

/**
 * Get styles for pending activation state
 *
 * @param props Props passed to Avatar component
 * @returns     Styles or empty object
 */
const getPendingActivationStyles = (props: AvatarProps) => {
  if (props['data-is-pending'] === false) {
    return {};
  }

  return {
    backgroundColor: colorNeutralBaseStyle.backgroundColor,
    color: colorNeutralBaseStyle.color,
    filter: 'none',
  };
};

export const MuiAvatar = styled(Avatar)<AvatarProps>(props => ({
  ...getAvatarSize(props),
  ...getInactiveStyles(props),
  ...getPendingActivationStyles(props),
}));
